AFRAME.registerComponent('virtik-item', {
    schema: {
        type: {type: 'string'},
        width: {type: 'number', default: 1},
        height: {type: 'number', default: 1},
        margin: { type: 'vec4', default: {x: 0, y: 0, z: 0, w: 0}},
    },
    init: function () {
    },
    update: function () {
    },
    tick: function () {
    },
    remove: function () {
    },
    pause: function () {
    },
    play: function () {
    },
});

export {}
